export default __webpack_public_path__ + "img/blozoNsm.4fe42808.svg";